# Schema reference

Auto-generated from `@cairntools/schema`. The fields below are the source-of-truth Zod schemas; every Cairn YAML file is validated against this exact shape.

> This page is regenerated on every build. Edit the Zod schema, not this file.

## Flow

- **`apiVersion`** — `string`
- **`kind`** — `string`
- **`metadata`** — `object`

  - **`name`** — `string`
  - **`description`** — `string`
  - **`owner`** — `string`
  - **`tags`** — `array`
    *Each item:*
      - **`(item)`** — `string`
  - **`platform`** — `string` · enum: `web`, `mobile`
- **`spec`** — `object`

  - **`entry`** — `string`
  - **`envs`** — `object`
  - **`hooks`** — `object`

    - **`pre`** — `array`
      *Each item:*
        - **`(item)`** — `string` · enum: `clear_cookies`, `clear_local_storage`, `logout`, `seed_user`, `reset_db_via_endpoint`
    - **`post`** — `array`
      *Each item:*
        - **`(item)`** — `string` · enum: `clear_cookies`, `clear_local_storage`, `logout`, `seed_user`, `reset_db_via_endpoint`
  - **`nodes`** — `object`

---

## Project config

- **`projectId`** — `string`
- **`teamId`** — `string`
- **`envs`** — `object`
- **`ci`** — `object`

  - **`driftPolicy`** — `string` · enum: `warn`, `block_on_high`, `block_any`
- **`hooks`** — `object`

  - **`pre`** — `array`
    *Each item:*
      - **`(item)`** — `string` · enum: `clear_cookies`, `clear_local_storage`, `logout`, `seed_user`, `reset_db_via_endpoint`
  - **`post`** — `array`
    *Each item:*
      - **`(item)`** — `string` · enum: `clear_cookies`, `clear_local_storage`, `logout`, `seed_user`, `reset_db_via_endpoint`
- **`extensions`** — `object`

  - **`selectorRecovery`** — `object`

    - **`provider`** — `string`
    - **`model`** — `string`
  - **`voiceCapture`** — `object`

    - **`provider`** — `string`
    - **`model`** — `string`
  - **`sourceLessScan`** — `object`

    - **`provider`** — `string`
    - **`model`** — `string`
- **`secrets`** — `array`
  *Each item:*
    - **`(item)`** — `string`
- **`fixtures`** — `object`
